import { IIconProps } from "@/components/icons/interface";

const DEFAULT_COLOR = "var(--theme-status-error, #D92D20)";

const HpTriangleAlertIcon = ({ width, height, color }: IIconProps) => {
  const strokeColor = color ?? DEFAULT_COLOR;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
    </svg>
  );
};

export { HpTriangleAlertIcon };
